import { Box, IconButton, Image } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { POSTER_DEMO_IMAGES } from '../posterDemoAssets';

interface VenueMapScreenProps {
  onBack: () => void;
}

export const VenueMapScreen = ({ onBack }: VenueMapScreenProps) => (
  <Box
    position="absolute"
    inset="5% 4% 5% 4%"
    bg="black"
    borderRadius="44px"
    overflow="hidden"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Image
      src={POSTER_DEMO_IMAGES.venueMap}
      alt="Venue map"
      maxW="100%"
      maxH="100%"
      objectFit="contain"
    />
    <IconButton
      aria-label="Close"
      icon={<CloseIcon boxSize="9px" />}
      size="xs"
      borderRadius="full"
      color="white"
      bg="blackAlpha.600"
      _hover={{ bg: 'blackAlpha.700' }}
      position="absolute"
      top="18px"
      right="18px"
      onClick={onBack}
    />
  </Box>
);
